/*
 * ms-mcards-nav — flechas para el carrusel de ms-media-cards.
 * ---------------------------------------------------------------------------
 * El carrusel es CSS puro (scroll-snap): en movil se desliza con el dedo y ahi
 * las flechas sobran. En escritorio no hay dedo, y el cliente de Koneli lo
 * dijo tal cual: «la navegacion a la derecha para verlos todos es complicada,
 * no hay una flecha que permita ir hacia la derecha si no deslizas».
 *
 * Es un CUSTOM ELEMENT, no un <script> suelto, porque el tema redibuja las
 * secciones con morph() y un script inline NO se vuelve a ejecutar: los
 * botones quedarian sin listeners y se sentiria «bugeado». Un custom element
 * se re-engancha solo al insertarse.
 *
 * Y el estado NO vive en variables: se lee del DOM en cada repintado
 * (scrollLeft del riel), asi que morph puede reemplazar lo que quiera.
 */
class MsMcardsNav extends HTMLElement {
  connectedCallback() {
    this.riel = this.closest('.ms-mcards')?.querySelector('.ms-mcards__track');
    this.prev = this.querySelector('[data-mcards-prev]');
    this.next = this.querySelector('[data-mcards-next]');
    if (!this.riel || !this.prev || !this.next) return;

    this.onClick = (ev) => {
      const b = ev.target.closest('[data-mcards-prev], [data-mcards-next]');
      if (!b || !this.contains(b)) return;
      const dir = b.hasAttribute('data-mcards-next') ? 1 : -1;
      this.riel.scrollBy({ left: dir * this.paso(), behavior: 'smooth' });
    };
    this.onScroll = () => {
      if (this.raf) cancelAnimationFrame(this.raf);
      this.raf = requestAnimationFrame(() => this.pintar());
    };

    this.addEventListener('click', this.onClick);
    this.riel.addEventListener('scroll', this.onScroll, { passive: true });
    this.ro = new ResizeObserver(() => this.pintar());
    this.ro.observe(this.riel);
    this.pintar();
  }

  disconnectedCallback() {
    this.removeEventListener('click', this.onClick);
    this.riel?.removeEventListener('scroll', this.onScroll);
    this.ro?.disconnect();
    if (this.raf) cancelAnimationFrame(this.raf);
  }

  /* Un paso = una tarjeta mas su hueco. Avanzar una PANTALLA entera se salta
     tarjetas cuando la ultima queda a medias, y el cliente pierde el hilo. */
  paso() {
    const card = this.riel.querySelector('.ms-mcards__card');
    if (!card) return this.riel.clientWidth;
    const gap = parseFloat(getComputedStyle(this.riel).columnGap) || 0;
    return card.getBoundingClientRect().width + gap;
  }

  pintar() {
    const max = this.riel.scrollWidth - this.riel.clientWidth;
    /* Sin desborde no hay nada que navegar: la fila se esconde por CSS en vez
       de dejar dos botones muertos. */
    this.toggleAttribute('data-sin-overflow', max <= 1);
    const x = this.riel.scrollLeft;
    this.prev.disabled = x <= 1;
    this.next.disabled = x >= max - 1;
  }
}

if (!customElements.get('ms-mcards-nav')) {
  customElements.define('ms-mcards-nav', MsMcardsNav);
}
